import request from '@/utils/request'

// ==================== 收银订单 ====================

/**
 * 创建收银订单
 */
export function createCashierOrder(data) {
  return request({
    url: '/retail/cashier/createOrder',
    method: 'post',
    data: data
  })
}

/**
 * 查询收银订单列表
 */
export function listCashierOrders(query) {
  return request({
    url: '/order/sell/page',
    method: 'get',
    params: query
  })
}

/**
 * 获取收银订单详情
 */
export function getCashierOrderDetail(orderId) {
  return request({
    url: '/retail/cashier/orderDetail',
    method: 'get',
    params: { orderId }
  })
}

/**
 * 获取订单详情
 */
export function getOrderDetail(orderId) {
  return request({
    url: '/order/sell/detail',
    method: 'get',
    params: { id: orderId }
  })
}

/**
 * 创建退货订单
 */
export function createRefundOrder(data) {
  return request({
    url: '/retail/cashier/refund',
    method: 'post',
    data: data
  })
}
